    document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".fbt-wrapper");

  if (!wrapper) return;

  /**
   * Quantity +
   */
  wrapper.addEventListener("click", (e) => {
    if (e.target.classList.contains("fbt-plus")) {
      const input = e.target.previousElementSibling;
      input.value = parseInt(input.value || 1) + 1;

      updateBundlePrice();
    }

    if (e.target.classList.contains("fbt-minus")) {
      const input = e.target.nextElementSibling;

      let qty = parseInt(input.value || 1);

      if (qty > 1) {
        input.value = qty - 1;
      }

      updateBundlePrice();
    }
  });

  /**
   * Checkbox change
   */
  wrapper.addEventListener("change", (e) => {
    if (e.target.classList.contains("fbt-product-checkbox")) {
      const row = e.target.closest(".fbt-item");

      if (e.target.checked) {
        row.classList.remove("fbt-disabled");
      } else {
        row.classList.add("fbt-disabled");
      }

      updateBundlePrice();
    }

    if (e.target.classList.contains("fbt-quantity")) {
      updateBundlePrice();
    }
  });

  /**
   * Calculate bundle total
   */
  function updateBundlePrice() {
    let total = 0;

    document.querySelectorAll(".fbt-item").forEach((item) => {
      const checkbox = item.querySelector(".fbt-product-checkbox");

      if (!checkbox.checked) return;

      const qty = parseInt(
        item.querySelector(".fbt-quantity").value || 1
      );

      const price = parseInt(
        checkbox.dataset.price || 0
      );

      total += price * qty;
    });

    const totalElement = document.querySelector(".fbt-total-price");

    if (totalElement) {
      totalElement.textContent =
        Shopify.formatMoney(total);
    }
  }

  /**
   * Return selected products
   */
  window.getFBTProducts = function () {

    let items = [];

    document.querySelectorAll(".fbt-item").forEach((item) => {

      const checkbox =
        item.querySelector(".fbt-product-checkbox");

      if (!checkbox.checked) return;

      items.push({
        id: Number(checkbox.dataset.variantId),
        quantity: Number(
          item.querySelector(".fbt-quantity").value
        )
      });

    });

    return items;

  };

  updateBundlePrice();
});
